/*global Modernizr, Splide, console, TECSlideCurrentSlide, TECSlideHideArrows, TECSlideDisableDrag */
/*jslint browser:true */

(function() {
  'use strict';

  var staff_modal_containers = document.querySelectorAll('.staff-modal-container');

  if(staff_modal_containers) {
    staff_modal_containers.forEach((staff_modal_container) => {
      const staff_modal = staff_modal_container.querySelector('.staff-modal'),
            staff_slider = staff_modal_container.querySelector('.staff-slider'),
            slider = new Splide(staff_slider, {
              type: 'slide',
              arrows: 'slider',
              pagination: false
            });

      slider.mount({ TECSlideCurrentSlide, TECSlideHideArrows, TECSlideDisableDrag });

      staff_modal_container.addEventListener('modal-open', (e) => {
        staff_modal.focus();

        var slide_index = e.detail.getAttribute('data-index');

        slider.go(parseInt(slide_index));
      });

      staff_modal.addEventListener('keydown', (e) => {
        if(e.key === 'Home') {
          slider.go(0);
        }

        if(e.key === 'End') {
          slider.go(slider.length);
        }

        if(e.key === 'ArrowRight') {
          slider.go('>');
        }

        if(e.key === 'ArrowLeft') {
          slider.go('<');
        }
      });
    });
  }
}());